import { graphql, useStaticQuery } from "gatsby";

const useSiteConfig = () => {
  const data = useStaticQuery(graphql`
    query {
      strapiSiteConfig {
        strapi_id
        facebook_link
        twitter_link
        instagram_link
        youtube_link
        footer_links {
          title
          add_link {
            title
            link {
              ...MenuFragment
            }
          }
        }
        footer_section {
          title
          content {
            data {
              content
            }
          }
          cta_1_link {
            ...MenuFragment
          }
          cta_1_title
          cta_2_title
          cta_2_link {
            ...MenuFragment
          }
        }
        contact_call_intro {
          data {
            contact_call_intro
          }
        }
        contact_whatsapp_intro {
          data {
            contact_whatsapp_intro
          }
        }
        whatsapp
        phone
      }
    }
  `);
  const {
    strapi_id,
    facebook_link,
    twitter_link,
    instagram_link,
    youtube_link,
    footer_links,
    footer_section,
    contact_call_intro,
    contact_whatsapp_intro,
    whatsapp,
    phone
  } = data?.strapiSiteConfig;
  return {
    strapi_id: strapi_id,
    facebook: facebook_link,
    twitter: twitter_link,
    instagram: instagram_link,
    youtube: youtube_link,
    footer_links: footer_links,
    footer_section: footer_section,
    contact_call_intro: contact_call_intro,
    contact_whatsapp_intro: contact_whatsapp_intro,
    whatsapp: whatsapp,
    phone: phone,
  };
};

export default useSiteConfig;
